import React, { Component } from "react";
import {
  company,
  loading,
  NavbarAdmin,
  Pagination,
  Modal,
  Select,
  DatePicker,
  DateRangeFields,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  format_date,
  activeOptions,
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission.js";
import { formatNumber } from "../../utils/formatting";

const PAGE_SIZE = 10;

// ตรงกับ LEAVE_TYPES / LEAVE_STATUSES ใน SNAPA-Backend/modules/admin/technician-leave/dtos/request/create-technician-leave.dto.js ห้ามเปลี่ยนค่าฝั่งนี้เดี่ยว ๆ
const LEAVE_TYPES = ["annual", "personal", "sick"];
const LEAVE_STATUSES = ["pending", "approved", "rejected"];
const LEAVE_STATUS_COLOR = { pending: "warning", approved: "success", rejected: "danger" };

// วันลาส่วนตัวของช่าง (ISS - ปฏิทินงานช่าง) - ใช้บล็อกการลงตารางงานที่หน้า scheduling.js (เฉพาะสถานะ approved)
// backend (technician-leave.route.js) ไม่รองรับกรองช่วงวันที่ฝั่ง server จึงดึงมาทั้งหมด (page: 0) แล้วกรอง/แบ่งหน้าเองที่นี่
export default class TechnicianLeaves extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_technician_uid: "",
      filter_leave_type: "",
      filter_status: "",
      filter_start_date: "",
      filter_end_date: "",

      page: 1,
      all_data: [],
      count: 0,
      data: [],
      data_technicians: [],

      modal_create: false,
      modal_update: false,

      // Form states
      uid: "",
      company_id: company?.id,
      technician_id: "",
      leave_type: "annual",
      note: "",
      start_date: "",
      end_date: "",
      status: "approved",
      is_active: "Active",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.GetTechnicians();
    this.Get();
  }

  GetTechnicians = async () => {
    const result = await GET("admin/technicians", { page: 0, data_search: "" });
    if (result?.status && Array.isArray(result.data)) {
      this.setState({
        data_technicians: result.data.map((tech) => ({
          ...tech,
          value: tech.uid,
          label: this.getTechnicianName(tech),
        })),
      });
    }
  };

  getTechnicianName = (tech) => {
    const fullName =
      [tech.first_name_th, tech.last_name_th].filter(Boolean).join(" ") ||
      [tech.first_name_en, tech.last_name_en].filter(Boolean).join(" ");
    return fullName || tech.technician_code || "-";
  };

  // "annual" ใช้คีย์ i18n "annual_leave" ที่มีอยู่แล้วทั้งระบบ (ไม่ใช้ "leave_type_annual" กันแปลซ้ำซ้อน)
  leaveTypeLabel = (value) => (value === "annual" ? t("annual_leave") : t("leave_type_" + value));

  leaveTypeOptions = () => LEAVE_TYPES.map((value) => ({ value, label: this.leaveTypeLabel(value) }));

  leaveStatusOptions = () => LEAVE_STATUSES.map((value) => ({ value, label: t("leave_status_" + value) }));

  // กรองช่วงวันที่ฝั่ง client (overlap กับช่วงที่เลือก) เพราะ backend ไม่รองรับ start_date/end_date เป็น query param
  applyDateRangeFilter = (rows, filterStartDate, filterEndDate) => {
    if (!filterStartDate && !filterEndDate) return rows;
    return rows.filter((item) => {
      if (filterStartDate && item.end_date < filterStartDate) return false;
      if (filterEndDate && item.start_date > filterEndDate) return false;
      return true;
    });
  };

  Get = async (page = 1) => {
    const { filter_technician_uid, filter_leave_type, filter_status, filter_start_date, filter_end_date } = this.state;
    loading(true);

    const result = await GET("admin/technician-leaves", {
      page: 0,
      technician_id: filter_technician_uid || "",
      leave_type: filter_leave_type || "",
      status: filter_status || "",
    });

    if (result?.status) {
      const all_data = this.applyDateRangeFilter(result.data || [], filter_start_date, filter_end_date);
      const start = (page - 1) * PAGE_SIZE;
      this.setState({
        all_data,
        data: all_data.slice(start, start + PAGE_SIZE),
        count: all_data.length,
        page,
      });
    }

    loading(false);
  };

  changePage = (page) => {
    const start = (page - 1) * PAGE_SIZE;
    this.setState({ page, data: this.state.all_data.slice(start, start + PAGE_SIZE) });
  };

  openCreate = () =>
    this.setState({
      modal_create: true,
      modal_update: false,
      uid: "",
      technician_id: "",
      leave_type: "annual",
      note: "",
      start_date: "",
      end_date: "",
      status: "approved",
      is_active: "Active",
    });

  openEdit = (item) =>
    this.setState({
      modal_create: false,
      modal_update: true,
      uid: item.uid,
      technician_id: item.technician_uid || "",
      leave_type: item.leave_type || "annual",
      note: item.note || "",
      start_date: item.start_date || "",
      end_date: item.end_date || "",
      status: item.status || "approved",
      is_active: item.is_active ? "Active" : "Inactive",
    });

  handleSave = async () => {
    const { uid, company_id, technician_id, leave_type, note, start_date, end_date, status, is_active } = this.state;

    if (!technician_id) {
      await alert("", "warning", t("warning"), t("tl_validate_technician"));
      return;
    }
    if (!start_date) {
      await alert("", "warning", t("warning"), t("tl_validate_start_date"));
      return;
    }
    if (!end_date) {
      await alert("", "warning", t("warning"), t("tl_validate_end_date"));
      return;
    }
    if (end_date < start_date) {
      await alert("", "warning", t("warning"), t("tl_validate_date_range"));
      return;
    }

    if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
      loading(true);

      const body = {
        company_id,
        technician_id,
        leave_type,
        note: note.trim(),
        start_date,
        end_date,
        status,
        is_active: is_active === "Active",
      };

      const result = !uid
        ? await POST("admin/technician-leaves", body)
        : await PUT("admin/technician-leaves/" + uid, body);

      if (result?.status === true) {
        alert("#", "success", t("success"), t("save_success"));
        this.setState({ modal_create: false, modal_update: false });
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  handleDelete = async (uid) => {
    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      loading(true);
      const result = await DELETE("admin/technician-leaves/" + uid, null);
      if (result?.status) {
        alert("#", "success", t("success"), t("delete_success"));
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  render() {
    const {
      data, count, page, data_technicians,
      filter_technician_uid, filter_leave_type, filter_status, filter_start_date, filter_end_date,
      modal_create, modal_update,
      technician_id, leave_type, note, start_date, end_date, status, is_active,
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarAdmin />
            <div className="body p-4 mt-3">
                {/* Header */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("tl_title")}</h3>
                        <div className="text-secondary text-14">{t("tl_desc")}</div>
                    </div>
                </div>

                {/* Filter Toolbar */}
                <div className="rounded-4 bg-white p-3 mb-3 shadow-sm border-0">
                    <div className="d-flex flex-wrap align-items-end justify-content-between gap-3">
                        <div className="d-flex flex-wrap gap-2 flex-grow-1 align-items-end">
                            <Select
                                className="form-control wpx-220"
                                options={data_technicians}
                                value={filter_technician_uid}
                                onChange={(e) => this.setState({ filter_technician_uid: e || "" })}
                                placeholder={t("tl_filter_all_technicians")}
                            />
                            <Select
                                className="form-control wpx-180"
                                options={this.leaveTypeOptions()}
                                value={filter_leave_type}
                                onChange={(e) => this.setState({ filter_leave_type: e || "" })}
                                placeholder={t("tl_filter_all_leave_types")}
                            />
                            <Select
                                className="form-control wpx-180"
                                options={this.leaveStatusOptions()}
                                value={filter_status}
                                onChange={(e) => this.setState({ filter_status: e || "" })}
                                placeholder={t("all_status")}
                            />
                            <DateRangeFields
                                type="th"
                                className="form-control"
                                fieldStyle={{ width: 160 }}
                                startPlaceholder={t("start_date")}
                                endPlaceholder={t("end_date")}
                                startValue={filter_start_date}
                                endValue={filter_end_date}
                                onChange={({ start, end }) => this.setState({ filter_start_date: start, filter_end_date: end })}
                            />
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() =>
                                        this.setState(
                                            {
                                                filter_technician_uid: "",
                                                filter_leave_type: "",
                                                filter_status: "",
                                                filter_start_date: "",
                                                filter_end_date: "",
                                            },
                                            () => this.Get(1)
                                        )
                                    }
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        {can("technician-leave.create") ? (
                        <button className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center" onClick={this.openCreate}>
                            <span className="me-2 text-16">+</span> {t("tl_add_btn")}
                        </button>
                        ) : null}
                    </div>
                </div>

                {/* Table */}
                <div className="bg-white rounded-4 shadow-sm overflow-hidden">
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "950px" }}>
                            <thead>
                                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 px-3 border-0">{t("tl_col_technician")}</th>
                                    <th className="py-3 px-3 border-0 text-center wpx-140">{t("tl_col_leave_type")}</th>
                                    <th className="py-3 px-3 border-0">{t("tl_col_date_range")}</th>
                                    <th className="py-3 px-3 border-0 text-center wpx-140">{t("status")}</th>
                                    <th className="py-3 px-3 border-0 text-center wpx-120">{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length === 0 ? (
                                    <tr>
                                        <td colSpan={5} className="text-center text-secondary py-5">
                                            <div className="d-flex flex-column align-items-center gap-2">
                                                <span>{t("no_data")}</span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    data.map((item, idx) => (
                                        <tr key={item.uid || idx} className="border-bottom border-light bg-white">
                                            <td className="px-3">
                                                <div className="text-dark text-14 fw-semibold">{item.technician_name || "-"}</div>
                                            </td>
                                            <td className="text-center">
                                                <div className="text-dark text-14">{this.leaveTypeLabel(item.leave_type)}</div>
                                            </td>
                                            <td className="px-3">
                                                <div className="text-dark text-14">
                                                    {format_date(item.start_date, "dd/mm/yyyy", "th")} - {format_date(item.end_date, "dd/mm/yyyy", "th")}
                                                </div>
                                                {item.note && <div className="text-secondary text-12 text-truncate" style={{ maxWidth: 260 }}>{item.note}</div>}
                                            </td>
                                            <td className="text-center">
                                                <span
                                                    className={`text-${LEAVE_STATUS_COLOR[item.status] || "secondary"} text-12 fw-bold bg-${LEAVE_STATUS_COLOR[item.status] || "secondary"}-light px-2 py-1 rounded-pill`}
                                                >
                                                    {t("leave_status_" + item.status)}
                                                </span>
                                            </td>
                                            <td className="text-center">
                                                <div className="d-flex align-items-center gap-2 justify-content-center">
                                                    <ActionIconButton label={can("technician-leave.update") ? t("edit") : t("view")} icon={can("technician-leave.update") ? ACTION_ICONS.edit : ACTION_ICONS.view} variant={can("technician-leave.update") ? "warning" : "primary"} onClick={() => this.openEdit(item)} />
                                                    {can("technician-leave.delete") ? (
                                                    <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" onClick={() => this.handleDelete(item.uid)} />
                                                    ) : null}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12 gap-2">
                    <div>
                        {t("showing")} {count === 0 ? 0 : formatNumber((page - 1) * PAGE_SIZE + 1)}-{formatNumber((page - 1) * PAGE_SIZE + data.length)} {t("of")} {formatNumber(count)} {t("tl_count")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / PAGE_SIZE) || 1} page={page} showFirstButton={false} showLastButton={false} onChange={(_, p) => this.changePage(p)} />
                </div>
            </div>

            {/* MODAL: CREATE / EDIT */}
            <Modal show={modal_create || modal_update} onHide={() => this.setState({ modal_create: false, modal_update: false })} centered contentClassName="border-0 rounded-4 shadow-lg">
                <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{modal_update ? t("tl_modal_edit") : t("tl_modal_create")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
<fieldset disabled={this.state.modal_update && !can("technician-leave.update")} className="border-0 p-0 m-0" style={{ minWidth: 0 }}>
                    <div className="row g-3">
                        <div className="col-12">
                            <label className="form-label text-14 text-dark mb-2">
                                {t("tl_field_technician")} <span className="text-danger">*</span>
                            </label>
                            <Select
                                className="form-control w-100"
                                options={activeOptions(data_technicians, technician_id)}
                                value={technician_id}
                                onChange={(e) => this.setState({ technician_id: e || "" })}
                                placeholder={t("tl_field_technician")}
                                disabled={modal_update}
                            />
                        </div>

                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark mb-2">{t("tl_field_leave_type")}</label>
                            <Select
                                className="form-control w-100"
                                sort={false}
                                options={this.leaveTypeOptions()}
                                value={leave_type}
                                onChange={(e) => this.setState({ leave_type: e || "annual" })}
                                placeholder={t("tl_field_leave_type")}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark mb-2">{t("status")}</label>
                            <Select
                                className="form-control w-100"
                                sort={false}
                                options={this.leaveStatusOptions()}
                                value={status}
                                onChange={(e) => this.setState({ status: e || "approved" })}
                                placeholder={t("status")}
                            />
                        </div>

                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark mb-2">
                                {t("start_date")} <span className="text-danger">*</span>
                            </label>
                            <DatePicker
                                type="th"
                                className="form-control py-2 text-dark"
                                value={start_date}
                                onChange={(val) => this.setState({ start_date: val || "", end_date: end_date && end_date < val ? val : end_date })}
                                placeholder={t("date_placeholder")}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark mb-2">
                                {t("end_date")} <span className="text-danger">*</span>
                            </label>
                            <DatePicker
                                type="th"
                                className="form-control py-2 text-dark"
                                value={end_date}
                                onChange={(val) => this.setState({ end_date: val || "" })}
                                placeholder={t("date_placeholder")}
                                min={start_date || undefined}
                            />
                        </div>

                        <div className="col-12">
                            <label className="form-label text-14 text-dark mb-2">{t("note")}</label>
                            <textarea className="form-control py-2" rows={3} value={note} onChange={(e) => this.setState({ note: e.target.value })} />
                        </div>

                        {/* Status */}
                        <div className="col-12 mt-2 border-top pt-3">
                            <h6 className="fw-bold mb-3 d-flex align-items-center">
                                <span className="icon text-primary me-2">{""}</span> {t("active")} / {t("inactive")}
                            </h6>
                            <div className="d-flex gap-4">
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="tlStatus"
                                        id="tlActive"
                                        checked={is_active === "Active"}
                                        onChange={() => this.setState({ is_active: "Active" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="tlActive">
                                        {t("active")}
                                    </label>
                                </div>
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="tlStatus"
                                        id="tlInactive"
                                        checked={is_active === "Inactive"}
                                        onChange={() => this.setState({ is_active: "Inactive" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="tlInactive">
                                        {t("inactive")}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
</Modal.Body>
                <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                        {t("cancel")}
                    </button>
                    {(!this.state.modal_update || can("technician-leave.update")) ? <button
                        className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                        onClick={this.handleSave}
                    >
                        <span className="icon me-2">{""}</span> {t("save")}
                    </button> : null}
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
